import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import './ProductCard.css';

export default function ProductCard({ product: { name, price, picture, persons }, endPoint }) {

  const defaultPic = picture ? `/products/${picture}` : '/default.png';


  const personIcons = [];
  for (let i = 0; i < persons; i++) {
    personIcons.push(<PersonIcon key={i} fontSize='small' />);
  }

  return (
    <div className="food-card" data-aos={`zoom-in`} data-aos-duration="1000">
      <div className="food-card-logo-container">
        <img className="logo" src={`${endPoint}/logo-w.svg`} alt="Logo" />
        <div className='persons-number'>
          {/* {personIcons} */}
        </div>
      </div>
      <div className="food-card-img-container">
        <img src={`${endPoint}${defaultPic}`} alt="Product" />
        <div className="food-card-title-container">
          <h3 className="food-card-title">{name}</h3>
          <p className="food-card-price">₪{price}</p>
        </div>
      </div>
    </div>
  );
}
